import $ from 'jquery';
import slick from 'slick-carousel';

var $slickElement = $('[data-slick]');
var $slickElementFirst = $('[data-slick]').first();
var $progressBar = $('.progress');
var $progressLabel = $( '.counter' );

// add counter
$slickElementFirst.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
  var index = (currentSlide ? currentSlide : 0) + 1; // currentSlide is undefined on init
  $progressLabel.html( pad(index, 2) + '/<span>' + pad(slick.slideCount, 2) + '</span>' );
});

// updated progress bar
$slickElementFirst.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var calc = Math.round(( (nextSlide) / (slick.slideCount-1) ) * 100);
  $progressBar.css('width', calc + '%'); 
});

// nav slider left
$('.prev').click(function(e) {
  e.preventDefault();
  $slickElement.slick('slickPrev');
});

// nav slider right
$('.next').click(function(e) {
  e.preventDefault();
  $slickElement.slick('slickNext');
});

// init slick
$slickElement.slick({
  arrows: false,
  swipeToSlide: true,
  rows: 0
});

// helpers
function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

// hide slick arrow if its on the last slide | show more carousel
$('.title-slide').on('afterChange', function(event, slick, currentSlide) {
  var $findNext = $(this).find('.slick-next');

  if (slick.currentSlide >= slick.slideCount - 1) {
    $findNext.hide()
  } else {
    $findNext.show()
  }
});


//Featured Carousel
// add counter
$( '.featured-carousel' ).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
  var index = (currentSlide ? currentSlide : 0) + 1; // currentSlide is undefined on init
  $( '.featured-counter' ).html( pad(index, 2) + '/<span>' + pad(slick.slideCount, 2) + '</span>' );
});

// updated progress bar
$( '.featured-carousel' ).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var calc = Math.round(( (nextSlide) / (slick.slideCount-1) ) * 100);
  $( '.featured-progress' ).css('width', calc + '%'); 
});